export default class ProductCategoryType {}

ProductCategoryType.Allergies = 'allergies';
ProductCategoryType.FleaAndTick = 'flea_and_tick';
// ProductCategoryType.Otc = 'otc';
// ProductCategoryType.Rx = 'rx';
